import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { generateTrackingObject } from "../../../core/global/global-country-functions";
import { trademoTrackingEvents } from "../../../core/global/trademo-tracking";
import { getApiUrl } from "../../../utils/baseUrl";
import { productDropdownConfig } from "./header-product-linking-dropdown-list";
import { CLOUDINARY_INTEL_BASE_URL } from "../../../utils/enum";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getUserProfileHandler } from "@redux/User/userDetails.action";

export default function ProductLinkingDropdown({ parentProductArr, callNavigation, isOpen, setIsOpen }) {
  const [getInTouchPopUp, setGetInTouchPopUp] = useState(false);
  const [selectedInactiveProduct, setSelectedInactiveProduct] = useState("");
  let user_active_plan = !!JSON.parse(localStorage.getItem("userCurrentPlan")) && !!JSON.parse(localStorage.getItem("userCurrentPlan")).user_active_plan ? JSON.parse(localStorage.getItem("userCurrentPlan")).user_active_plan : "trademo_intel_us_enterprise";
  const productConfig = productDropdownConfig() ?? null;
  const dispatch = useDispatch();

  const callingTrackingEvents = (eventName) => {
    trademoTrackingEvents(eventName, generateTrackingObject("intel", !!window && !!window.location && !!window.location.pathname && window.location.pathname !== "" ? window.location.pathname : "", user_active_plan));
  };

  const onClickSubProducts = (key, url, pendo_event) => {
    if (!(key && url)) {
      setIsOpen(false);
      return;
    }
    if (pendo_event) {
      callingTrackingEvents(pendo_event);
    }
    callNavigation(key, "", url);
  };

  const handleGetInTouchSubmit = (e) => {
    e.stopPropagation();
    let userData = JSON.parse(localStorage.getItem("userData")).session_id;
    let data = parentProductArr.filter((item) => item.is_subscribed && item.days_left < -1).map((item) => item.product_name);

    const params = {
      planId: userData ? userData : null,
      countries: data.join(","),
      key: "All Apps Intel",
    };
    if (selectedInactiveProduct !== "") {
      params.product = selectedInactiveProduct;
    }
    axios
      .get(getApiUrl("notifySales"), { params })
      .then((res) => {
        if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
          if (selectedInactiveProduct === "") toast.success(res.data.message);
          else toast.success("Thanks for showing interest. Your account manager will get in touch with you shortly.");
        } else {
          toast.error(res.data.message ? res.data.message : "Something went wrong. Please try again later !!!");
        }
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again later !!!");
      })
      .finally(() => {
        setGetInTouchPopUp(false);
        setSelectedInactiveProduct("");
      });
  };

  useEffect(() => {
    if (parentProductArr) {
      let refresh = false;
      for (let i = 0; i < parentProductArr.length; i++) {
        if ((!parentProductArr[i].product_ui_name || !parentProductArr[i].product_ui_description) && parentProductArr[i].product_name !== "userManagement") {
          refresh = true;
          break;
        }
      }

      if (refresh) {
        dispatch(getUserProfileHandler({ isUpdated: true }));
      }
    }
  }, []);

  return (
    <>
      {isOpen ? (
        <div className="tw-p-4 tw-bg-white tw-absolute tw-right-4 tw-top-14 tw-shadow-2xl tw-rounded-lg">
          <div className="product-array-container tw-flex tw-flex-col tw-gap-6">
            {parentProductArr &&
              parentProductArr.map((item) => {
                if (item.product_name === "userManagement" || !productConfig?.[item.product_name]) return null;
                return (
                  <div key={item.product_name}>
                    <div className="tw-pl-2">
                      <div
                        className={`tw-flex tw-justify-between tw-gap-8 tw-items-center tw-w-full tw-cursor-pointer`}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (item.is_subscribed && item.days_left >= 0) {
                            onClickSubProducts(productConfig[item.product_name].redirectionKey, productConfig[item.product_name].redirectionUrl, productConfig[item.product_name].pendo_event);
                          } else {
                            setGetInTouchPopUp(true);
                            setSelectedInactiveProduct(item.product_ui_name);
                          }
                        }}>
                        <div className={`tw-flex tw-gap-1 tw-justify-center tw-items-center header-product-linking-dropdown-list-sub-products ${!(item.is_subscribed && item.days_left >= 0) ? "tw-opacity-80" : "tw-opacity-100"}`}>
                          <img className="" src={productConfig[item.product_name].imageUrl} width={24} height={24} />
                          <div className="tw-block">
                            <div className="tw-text-sm tw-font-medium tw-text-gray-900">{item.product_ui_name}</div>
                            <div className="tw-text-xs tw-text-gray-900">{item.product_ui_description}</div>
                          </div>
                        </div>
                        {item.is_subscribed && item.days_left >= 0 ? (
                          <div>
                            <img className="navigation-arrow" src={`${CLOUDINARY_INTEL_BASE_URL}/v1694768003/intel/icons/nav_arrow_xsqxgi.svg`} alt="navigation-arrow" />
                          </div>
                        ) : (
                          <div>
                            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1687950013/intel/icons/Lightning-alt_mlxyoq.svg" alt="lightning" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      ) : (
        <></>
      )}
      {getInTouchPopUp ? (
        <Modal
          show={getInTouchPopUp}
          onHide={() => {
            setGetInTouchPopUp(false);
            setSelectedInactiveProduct("");
          }}
          keyboard={false}
          centered
          className="trademo-modal company-profile-get-in-touch-modal">
          <Modal.Header>
            <Modal.Title>
              <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg`} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            You do not have access to <b>{selectedInactiveProduct}</b>. Connect with your account manager to get access.
          </Modal.Body>
          <Modal.Footer className="justify-content-end">
            <button type="button" className="btn btn-secondary" onClick={() => setGetInTouchPopUp(false)}>
              Cancel
            </button>
            <button type="button" className="btn btn-primary trademo-new-btn" onClick={handleGetInTouchSubmit}>
              Get in Touch
            </button>
          </Modal.Footer>
        </Modal>
      ) : (
        <></>
      )}
    </>
  );
}
